/** Kompakter Verschleiß-Ring statt Balken – dieselbe Statuslogik wie .meter. */
export default function WearRing({ fraction, status, size = 30 }: {
  fraction: number; status: "OK" | "WARNING" | "CRITICAL" | string; size?: number;
}) {
  const stroke = Math.max(3, Math.round(size / 9));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.min(1, Math.max(0, fraction));
  const color = status === "CRITICAL" ? "var(--crit)" : status === "WARNING" ? "var(--warn)" : "var(--ok)";

  return (
    <svg className="wear-ring" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--surface-3)" strokeWidth={stroke} />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
              strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
              transform={`rotate(-90 ${size / 2} ${size / 2})`} />
    </svg>
  );
}
